@if(DataLoaded){
<div style="padding:30px; display:flex; flex-direction:column; gap:10px; align-content:center">
  <div style="height:300px">
    <rms-table [data]="TrafficNotes" [columns]="TrafficNotesColumns" [IncludePaginator]="false" [IncludeSearch]="false"></rms-table>
  </div>
  <button class="btn-bg-green" mat-button (click)="onClickNewNote()">Add Note</button>
</div>
}
